import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { awsClientGateway } from "./common/gateway";
import { logMessage } from "../utils/amplifyLogger";
import { clientLog } from "./logging";
import type { RootState } from "../store/types";

export const setOutboundCallerId = createAsyncThunk<
  string,
  string,
  { state: RootState }
>(
  "outboundCall/setOutboundCallerId",
  async (outboundPhoneNumber: string, { getState, rejectWithValue }) => {
    const connectedInstance = getState().userInstance.connectedInstance;
    const instanceId = connectedInstance?.instanceId ?? "";
    const payload = { outboundPhone: outboundPhoneNumber.replace(/-/g, "") };

    try {
      await awsClientGateway({
        pathTemplate: `/outboundPhone/${instanceId}`,
        method: "POST",
        body: { ...payload },
      });
      return outboundPhoneNumber;
    } catch (error) {
      clientLog({
        component: `outboundCall`,
        message: `Something went wrong in setOutboundCallerId API => ${error}`,
      });
      logMessage(
        `outboundCall`,
        `Something went wrong in setOutboundCallerId API => ${error}`,
        `error`,
      );
      return rejectWithValue("Error in setOutboundCallerId api endpoint");
    }
  },
);

export const getCallEndedStatus = createAction(
  "outboundCall/getCallEndedStatus",
);
